import React, { FunctionComponent, ReactElement, useCallback } from "react";
import styled from "@mui/material/styles/styled";
import { BackButton } from "../components/diagnosticAgent/common/backButton";
import { useHistory } from "react-router-dom";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { MobileView } from "../util/aKaunGeneralUtil";
import { Theme } from "@mui/material";
import { scrollableStyle } from "fe-common/ui/commonStyles";
import { contentZIndex } from "fe-common/ui/stacking";
//region [[ Styles ]]
const MobileExpandViewView = styled("div")(({ theme }: { theme?: Theme }) => ({
  width: "calc(100% + 14px)",
  margin: "0 -7px", // Kill the default padding
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  [theme.breakpoints.down(MobileView)]: {
    ...scrollableStyle,
    position: "absolute",
    top: "0",
    left: "0",
    backgroundColor: "white",
    margin: "0",
    width: "100%",
    height: "100%",
    zIndex: contentZIndex,
  },
}));

const TopArea = styled("div")({
  display: "flex",
  paddingTop: "14px",
  paddingBottom: "0px",
  flexFlow: "row",
  backgroundColor: KahunColorMap.Secondary,
  "@supports (padding-top: env(safe-area-inset-top))": {
    // iphone safe-area fix
    paddingTop: "env(safe-area-inset-top)",
  },
});

const BackButtonContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  marginRight: "5px",
  marginLeft: "8px",
});

const StyledBackButton = styled(BackButton)({
  padding: 0,
  color: "white",

  "& .back-button": {
    color: "white",
  },
});
//endregion [[ Styles ]]
//region [[ Props ]]
//endregion [[ Props ]]
//region [[ Functions ]]
interface MobileExpandViewProps {
  showTopArea?: boolean;
  topProgressBar?: ReactElement;
  topAreaTitle?: ReactElement;
  className?: string;
  children?: ReactElement | ReactElement[];
}
//endregion [[ Functions ]]
export const MobileExpandView: FunctionComponent<MobileExpandViewProps> = ({
  showTopArea = true,
  topProgressBar,
  topAreaTitle,
  className,
  children,
}) => {
  const history = useHistory();

  const handleBackClicked = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <MobileExpandViewView className={className}>
      {topProgressBar}
      {showTopArea && (
        <TopArea>
          <BackButtonContainer onClick={handleBackClicked}>
            <StyledBackButton color={"white"} />
            {topAreaTitle}
          </BackButtonContainer>
        </TopArea>
      )}
      {children}
    </MobileExpandViewView>
  );
};
